module.exports = __webpack_public_path__ + "img/func-top.2e79bb52.png";